import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./components/shared/variables.css"
import HomePage from "./pages/HomePage";
import Error from "./pages/Error";
import MainLayout from "./pages/MainLayout";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/*" element={<Error />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
